import http from '@/plugins/axios/axios';

export default class AutorizacaoSuporteService {

    autorizar(idEmpresa, email) {       
        return http.get('/api/autorizacao-suporte/autorizar?aut=' + idEmpresa + '&email=' + email);
    } 
}